import {Action, Module, Mutation, VuexModule,} from 'vuex-module-decorators';
import $http from '../services/api';
import type {ILegalText, LegalTextLang, LegalTextType,} from '../../../../libs/types/src/lib/types';

@Module({namespaced: true, name: 'legaltext'})
export default class LegaltextsManagement extends VuexModule {
  _legalTexts: ILegalText[] = [];
  _isLoading = false;

  @Mutation
  setLoading(loadingState = false) {
    this._isLoading = loadingState
  }

  @Mutation
  setLegalTexts(data: ILegalText[]) {
    this._legalTexts = data;
  }

  @Mutation
  setLegalTextProp<T extends keyof ILegalText>({
                                                 type,
                                                 lang,
                                                 property,
                                                 value
                                               }: { type: LegalTextType, lang: LegalTextLang, property: T, value: any }) {
    let foundText = this._legalTexts.find(t => t.type == type && t.lang == lang);

    if (!foundText) {
      foundText = {type, lang, text: null, version: 0}
      this._legalTexts.push(foundText);
    }

    foundText[property] = value;
  }


  @Action
  async loadLegalTexts() {
    this.context.commit('setLoading', true);
    const legaltexts = await $http.get('legaltexts').then((response) => response.data);
    this.context.commit('setLoading', false);
    this.context.commit('setLegalTexts', legaltexts);
    return legaltexts;
  }


  @Action({rawError: true})
  async updateOrCreateText(legalText: ILegalText) {
    this.context.commit('setLoading', true);

    try {
      if (legalText.id) {
        const resp = await $http.put('legaltexts' + '/' + legalText.id, legalText);
      } else {
        const resp = await $http.post('legaltexts' + '/', legalText);
      }
      this.context.dispatch('loadLegalTexts');
    } finally {
      this.context.commit('setLoading', false);
    }
  }

  get legalTexts(): ILegalText[] {
    return this._legalTexts;
  }

  get legalTextByTypeAndLang() {
    return (type: LegalTextType, lang: LegalTextLang) => this.legalTexts.find(t => t.type == type && t.lang == lang) ?? {}
  }
}
